<template>
    <div
        class="form-horizontal"
        encregion="multipart/form-data"
        @submit.prevent="store"
        @keydown="form.errors.clear($event.target.name)"
    >
        <table class="table table-striped">
            <thead>
                <tr>
                    <th>{{ uLang('app.name') }}</th>
                    <th>{{ uLang('app.action') }}</th>
                </tr>
            </thead>
            <draggable v-model="regions" element="tbody" handle=".handle">
                <tr v-for="region in regions">
                    <td class="region-name">
                        <div style="display: flex; width: 100%;">
                            <i class="fa fa-bars handle" />
                            <input
                                type="text"
                                v-if="region.editable"
                                class="form-control"
                                :name="region.value"
                                v-model="form['value'][region.id]"
                            >
                            <span v-if="!region.editable">
                              {{ region.value }}
                            </span>
                        </div>
                    </td>
                    <td class="region-action">
                        <a href="#"
                           @click.prevent="removeRegion(region)"
                           class="btn btn-danger"
                           v-if="region.deleteable"
                           :title="uLang('app.delete_region')"
                        >
                            <i class="fa fa-trash" />
                        </a>
                    </td>
                </tr>
            </draggable>
        </table>

        <div class="form-group">
            <div class="input-group">
                <input
                    type="text"
                    class="form-control"
                    name="new"
                    v-model="newRegion"
                    :placeholder="uLang('app.type_new_region')"
                    :title="uLang('app.add_new_region')"
                >
                <span class="input-group-btn">
                    <button
                        type="button"
                        class="btn btn-success"
                        @click="addRegion"
                        :disabled="form.busy"
                    >
                        {{ uLang('app.create_entity', { entity: lang('app.region') }) }}
                    </button>
                </span>
            </div>
        </div>

        <div class="form-group">
            <input
                :disabled="form.busy"
                type="button"
                :value="uLang('app.save_setting')"
                @click="store()"
                class="btn btn-brand"
            />
        </div>
    </div>
</template>

<script>
    import Form from '~/Form/Form'
    import { ErrorAlert, SuccessAlert, DestroyAlert } from '~/Swals'
    import Draggable from 'vuedraggable'

    export default {
        name: 'form-setting-regions',
        components: {
            Draggable
        },
        props: {
            settingId: {
                required: true,
            },
        },
        data() {
            return {
                form: new Form({
                    value: {},
                }),
                newRegion: '',
                regions: []
            }
        },
        mounted() {
            this.retrieveValues();
        },
        methods: {
            async store() {
                let formData = {}

                for (const [key, region] of Object.entries(this.form.value)) {
                    formData[region] = parseInt(key)
                }

                // Swapping form keys with values to ensure the order persists
                // Bit hacky, gets fixed in backend
                this.form.value = formData

                this.form['patch']('/api/admin/settings/' + this.settingId)
                    .then(response => {
                        this.setValues(response);
                        new SuccessAlert({
                            text: this.uLang('app.entity_updated', { entity: lang('app.regions') })
                        }).show();
                    })
                    .catch(() => {
                        new ErrorAlert({
                            title: uLang('app.oops_something_went_wrong'),
                            text: uLang('app.all_inputs_need_to_be_filled'),
                        }).show();
                    });
            },
            setValues(data) {
                this.form.value = {};
                this.regions = data;

                data.forEach(region => {
                    if (region.editable) {
                        this.form.value[region.id] = region.value;
                    }
                });
            },
            async retrieveValues() {
                const { data } = await window.axios.get('/api/admin/settings/' + this.settingId + '/values');

                this.setValues(data);
            },
            addRegion() {
                if (this.newRegion === '') {
                    return;
                }

                this.regions.push(
                    {
                        id: this.newRegion,
                        value: this.newRegion,
                        deleteable: 1,
                        editable: 1
                    }
                );
                this.form.value[this.newRegion] = this.newRegion;
                this.newRegion = '';
            },
            removeRegion(region) {
                new DestroyAlert({ entity: this.lang('app.region') }).show().then(async () => {
                    delete this.form.value[region.id];

                    //remove the region from the table
                    this.regions = this.regions.filter(current_region => current_region.value != region.value);
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .region-name {
        width: 70%;
    }

    .region-action {
        width: 30%;
    }

    .handle {
        cursor: grab;
        padding: 10px;
        text-align: center;
        &:active {
            cursor: grabbing;
        }
    }
</style>
